import { getGPUTier } from "@/utils/gpu"
import { getProductName } from "@/utils/product-name"
import { pushDialog } from "./dialogs-state"
import { ConfirmDialog } from "@/components/Dialogs/ConfirmDialog"
// eslint-disable-next-line no-restricted-imports -- Phase 1: store-layer i18n
import i18n from "@/i18n"
import { atom } from "jotai"
import { store } from "./store"
import { disableSentryGlobally, setGlobalSentryContext } from "@/telemetry/sentry-peers"

const GPU_TIER_SUPPORT_THRESHOLD = 2
const gpuAssessmentComplete = atom<boolean>(false)

export async function assessGPUPerformance() {
	if (store.get(gpuAssessmentComplete)) {
		return
	}

	const gpuTier = await getGPUTier()
	store.set(gpuAssessmentComplete, true)

	setGlobalSentryContext("GPU Tier", gpuTier)

	if (gpuTier.type === "BENCHMARK" && gpuTier.tier < GPU_TIER_SUPPORT_THRESHOLD) {
		pushDialog(ConfirmDialog, {
			title: i18n.t("store:gpuState.gpuPerformanceWarningTitle"),
			message: i18n.t("store:gpuState.gpuPerformanceWarningMessage", {
				productName: getProductName(),
			}),
			trackingViewName: "gpu_performance_warning",
			primary: {
				title: i18n.t("common:action.continue"),
				trackingLabel: "continue_anyway",
			},
		})

		disableSentryGlobally()
	}
}
